import { helpers } from '../helpers.js';

var narrative = {
	locale: 'en', // default

	init: function () {
		const self = this;

		if ( typeof narrativeItems !== 'undefined' && typeof narrativeItems === 'object' && Object.keys(narrativeItems).length > 0 ) {
			self.checkForLocale();
			self.loadItems();
		}
	},

	checkForLocale: function() {
		const self = this;
		
		// Get primary locale (e.g., 'en-US', 'cs-CZ')
		const fullLocale = navigator.language || navigator.userLanguage;
		self.locale = fullLocale.split( '-' )[0].toLowerCase();
	},

	loadItems: function() {
		const self = this;

		self.locale = narrativeItems[ self.locale ] ? self.locale : 'en';

		if( ! narrativeItems[ self.locale ] ) {
			jQuery( '.block-narrative' ).addClass( 'd-none' );
			return false;
		}

		narrativeItems[ self.locale ].forEach(function( item, index ) {
			let realIndex = index + 1;
			let narrativeID = `#narrative-${realIndex}`;

			jQuery( `${narrativeID} h2` ).text( item.title );
			jQuery( `${narrativeID} p` ).text( item.text );
			jQuery( `${narrativeID} a` ).attr( 'href', item.link );
			jQuery( `${narrativeID} a` ).append( item.picture );
		});
	},
};

export { narrative };